import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { Observable, take } from "rxjs";
import { InvitationDetails } from "../../domain/invitation";
import { InvitationsService } from "../../services/invitations.service";

export const invitationsResolver: ResolveFn<InvitationDetails[]> = (): Observable<InvitationDetails[]> => {
  const invitationsService = inject(InvitationsService);

  return invitationsService.getPendingInvitations$().pipe(take(1));
};
